'use client'

import Image from 'next/image'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

import type { AttachmentWorkflow } from '@/services/http/ideasService/getWorkflow'

type AttachmentViewerModalProps = {
  attachment: AttachmentWorkflow | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AttachmentViewerModal({
  attachment,
  open,
  onOpenChange,
}: AttachmentViewerModalProps) {
  if (!attachment) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle className="text-left">
            {attachment.originalName}
          </DialogTitle>
        </DialogHeader>
        <div className="flex max-h-[80vh] items-center justify-center overflow-auto">
          <Image
            src={attachment.url}
            alt={attachment.originalName}
            width={1200}
            height={800}
            className="h-auto w-full object-contain"
            unoptimized
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
